import React from "react";
import { Button } from "../ui/button";
import { ArrowRight, Mail, FolderGit2 } from "lucide-react";
import { heroData } from "../../mock/portfolioData";

function scrollToSection(sectionId) {
  const el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function HeroSection() {
  return (
    <section className="relative border-b border-slate-800/80 bg-gradient-to-b from-black/80 via-[#05040a] to-black/80">
      <div className="mx-auto flex max-w-5xl flex-col gap-10 px-4 pb-16 pt-24 sm:px-6 sm:pb-24 sm:pt-32 lg:flex-row lg:items-center lg:px-8">
        <div className="flex-1 space-y-6">
          <p className="retro-nav-link text-cyan-300">
            TECHNICAL CONSULTANT · AI ENGINEER
          </p>
          <h1 className="text-3xl font-semibold tracking-tight text-slate-50 sm:text-4xl lg:text-[2.8rem]">
            {heroData.headline}
          </h1>
          <p className="max-w-xl text-sm leading-relaxed text-slate-300 sm:text-base">
            {heroData.subtitle}
          </p>
          <p className="text-xs font-medium text-slate-400">
            Based in <span className="font-semibold text-slate-100">{heroData.location}</span>
          </p>

          <div className="flex flex-wrap gap-3 pt-2">
            <Button
              variant="default"
              className="retro-button group border-cyan-400/70 bg-slate-950 px-6 text-cyan-100 shadow-[0_0_20px_rgba(34,211,238,0.25)] transition-all hover:border-pink-400/80 hover:bg-black hover:text-pink-100"
              onClick={() => scrollToSection("projects")}
            >
              <FolderGit2 className="mr-1.5 h-3.5 w-3.5" />
              <span>View Projects</span>
            </Button>
            <Button
              variant="outline"
              className="retro-button border-slate-700 bg-transparent px-6 text-slate-100 hover:border-cyan-400/80 hover:text-cyan-100"
              onClick={() => scrollToSection("contact")}
            >
              <Mail className="mr-1.5 h-3.5 w-3.5" />
              <span>Get in Touch</span>
            </Button>
          </div>
        </div>

        <div className="mt-4 flex flex-1 justify-end lg:mt-0">
          <div className="retro-card relative w-full max-w-xs rounded-2xl border border-slate-800 bg-black/70 p-5">
            <div className="pointer-events-none absolute -inset-px rounded-2xl border border-cyan-400/20 mix-blend-screen" />
            <div className="mb-4 flex items-center justify-between">
              <div>
                <p className="retro-nav-link text-cyan-400">PROFILE</p>
                <p className="text-sm font-semibold text-slate-50">
                  {heroData.name}
                </p>
                <p className="text-xs text-slate-400">{heroData.title}</p>
              </div>
              <span className="inline-flex h-7 items-center rounded-sm border border-emerald-400/60 bg-emerald-500/10 px-2 text-[10px] font-mono uppercase tracking-[0.16em] text-emerald-300">
                OPEN TO ROLES
              </span>
            </div>
            <ul className="space-y-2 text-xs text-slate-300">
              <li className="flex justify-between">
                <span className="font-mono text-[11px] text-slate-400">FOCUS</span>
                <span className="font-medium text-slate-50">
                  AI Search · RAG · Chatbots
                </span>
              </li>
              <li className="flex justify-between">
                <span className="font-mono text-[11px] text-slate-400">STRENGTH</span>
                <span className="font-medium text-slate-50">
                  End-to-end delivery
                </span>
              </li>
              <li className="flex justify-between">
                <span className="font-mono text-[11px] text-slate-400">EXPERIENCE</span>
                <span className="font-medium text-slate-50">2+ years</span>
              </li>
            </ul>
            <button
              type="button"
              className="mt-4 inline-flex w-full items-center justify-between rounded-sm border border-slate-700 bg-slate-900 px-3 py-2 text-[10px] font-mono uppercase tracking-[0.2em] text-slate-100 transition-colors hover:border-cyan-400 hover:text-cyan-100"
              onClick={() => scrollToSection("experience")}
            >
              VIEW EXPERIENCE TIMELINE
              <ArrowRight className="h-3 w-3" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
